import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
import { generateRandomColorCode } from 'modules/theme';
import Select from 'react-select-plus/lib/Select';

class TagAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData) {
      this.state = {
        name: this.props.editData.name,
        colourCode: this.props.editData.colourCode,
        moduleName: this.props.editData.moduleName,
        parentTag: this.props.editData.parentTag,
      };
    } else {
      this.state = {
        name: '',
        colourCode: generateRandomColorCode(),
        moduleName: '',
        parentTag: ''
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: '',
      colourCode: '',
      moduleName: '',
      parentTag: ''
    });
  }

  // generateParamsFromArray(tData) {
  //   let options = [];
  //   for (const key in tData) {
  //     options.push({
  //       value: tData[key],
  //       label: key
  //     });
  //   }
  //   // console.log('options', options);
  //   return options;
  // }

  generateParamsFromArray(tData) {
    return tData.map(tD => ({
      value: tD._id,
      label: tD.name
    }));
  }

  renderModuleName() {
    return (
      <FormGroup>
        <ControlLabel>Module Name</ControlLabel>
        <Select
          placeholder="Select a Module Name"
          onChange={item => {
            if (item) {
              this.setState({ moduleName: item.value || 'SIP' });
            } else {
              this.setState({ moduleName: '' });
            }
          }}
          value={this.state.moduleName}
          options={this.generateParamsFromArray(this.props.moduleNameList)}
        />
      </FormGroup>
    );
  }

  renderTag() {
    return (
      <FormGroup>
        <ControlLabel>Parent Disposition</ControlLabel>
        <Select
          placeholder="Choose a parent"
          onChange={item => {
            if (item) {
              this.setState({ parentTag: item.value || 'SIP' });
            } else {
              this.setState({ parentTag: '' });
            }
          }}
          value={this.state.parentTag}
          options={this.generateParamsFromArray(this.props.listData)}
        />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }

  saveData(e) {
    let _this = this;
    e.preventDefault();
    let Name = this.state.name || "";
    Name = Name.trim();
    let tData = {
      name: Name,
      colourCode: this.state.colourCode,
      moduleName: this.props.moduleId,
      parentTag: this.state.parentTag
    };
    if (this.props.editData) {
      this.mAPI.sendPostAPI(
        `setting/tag/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`Tag ${tData.name} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/tag',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = [" "];
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          {/* <FormColumn></FormColumn> */}
          <FormColumn>
            {this.renderFormGroup('Name', {
              type: 'text',
              defaultValue: '',
              placeholder: 'Name',
              autoFocus: true,
              required: true,
              id: 'name',
              value: this.state.name,
              maxLength: 25,
              onKeyDown: e => {
                exceptThisSymbols.includes(e.key) && e.preventDefault()
              },
              onChange: e => {
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              <ControlLabel>Color code</ControlLabel>
              <FormControl
                type="color"
                value={this.state.colourCode}
                onChange={e => {
                  this.setState({ colourCode: e.target.value });
                }}
                id="colourCode"
              />
            </FormGroup>
          </FormColumn>
        </FormWrapper>
        {this.renderTag()}
        {/* {this.renderModuleName()} */}
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );
  }
}

TagAddEdit.propTypes = {
  group: PropTypes.array
};

TagAddEdit.contextTypes = {
  __: PropTypes.func
};

export default TagAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/components/TagAddEdit.js